import React from 'react';
import {
  Menu,
  MenuItem,
  Paper,
} from 'material-ui';
import {
  translate as t,
} from 'admin-on-rest';

const DEFAULT_SIZE = 140;
const MAX_CHARS_VISIBLE = 18;

const truncate = (str) => str && str.length > MAX_CHARS_VISIBLE ? `${str.substring(0, MAX_CHARS_VISIBLE - 3)}...` : str;

class ItemWrapper extends React.PureComponent {
  state = {
    rightClickMenuIsVisible: false,
  }

  onContextMenu = (ev) => {
    ev.preventDefault();
    this.showRightClickMenu();
  }

  remove = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onRemove();
    this.hideRightClickMenu();
  }

  update = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.onUpdate();
    this.hideRightClickMenu();
  }

  showRightClickMenu = () => this.setState({
    rightClickMenuIsVisible: true,
  });

  hideRightClickMenu = () => this.setState({
    rightClickMenuIsVisible: false,
  });

  render() {
    const {
      title, onClick, icon,
      translate, onRemove, onUpdate,
    } = this.props;
    return (
      <div
        role="presentation"
        style={{
          position: 'relative',
          display: 'inline-flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          width: DEFAULT_SIZE,
          marginBottom: 8,
        }}
        onClick={onClick}
        onContextMenu={this.onContextMenu}
        onMouseLeave={this.hideRightClickMenu}
      >
        {icon}
        <span
          style={{
            userSelect: 'none',
            WebkitUserSelect: 'none',
            WebkitTouchCallout: 'none',
          }}
        >{truncate(title)}
        </span>
        { this.state.rightClickMenuIsVisible && (
          <Paper
            style={{
              position: 'absolute',
              left: '100%',
              top: 0,
              zIndex: 100,
            }}
          >
            <Menu>
              {
                onUpdate && (
                  <MenuItem
                    primaryText={translate('change')}
                    onClick={this.update}
                  />
                )
              }
              {
                onRemove && (
                  <MenuItem
                    primaryText={translate('remove')}
                    onClick={this.remove}
                  />
                )
              }
            </Menu>
          </Paper>
        )}
      </div>
    );
  }
}

export default t(ItemWrapper);

